export default [
  {
    icon: 'HomeIcon',
    pageName: 'admin.dashboard',
    title: 'Convocatorias',
    sort: 0
  }
]
